import { Injectable } from '@angular/core';
import { captureAndReraiseAsync } from 'src/app/services/decorators/captureAndReraiseAsync';
import { UserRemoveListInputDTO } from '../room/room-leave-by-id-use-case.service';
import { MemberListRemoteRepository } from 'src/app/module/chat/data/repository/member/member-list-remote-repository.service';

@Injectable({
  providedIn: 'root'
})
export class RemoveMemberUseCaseService {

  constructor(
    private memberRemoteDataSourceService: MemberListRemoteRepository,
  ) { }


  @captureAndReraiseAsync('RoomRepositoryService/removeMemberToRoom')
  async execute(data: UserRemoveListInputDTO) {
    const result = await this.memberRemoteDataSourceService.removeMemberFromRoom(data)

    return result
  }
}
